import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    fetchCartCount: false,
    cartItemIndexChanged: null,
    fetchCartItems: null,
    fetchPhysicalSaveLaterItems: null,
    fetchVirtualSaveLaterItems: null,
    fetchAddToSaveLater: null,
    fetchDeleteFromSaveLater: null,
    fetchDeleteItemFromCart: null,
    patchSaveLaterItemFromCart: null,
    deleteItemFromCart: null,
    promoCode: '',
    sameAsShipping : {
        isSame : false,
        billingAddress : {}
    }
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        setisSameAddress:(state , action) =>{
            state.sameAsShipping.isSame = action.payload
        },
        setBillingAddress:(state , action) =>{
            state.sameAsShipping.billingAddress = action.payload
        },
        setFetchCartTotalItem: (state, action) => {
            state.fetchCartCount = action.payload;
        },
        setCartItemIndexChanged: (state, action) => {
            state.cartItemIndexChanged = action.payload;
        },
        setFetchCartItems: (state, action) => {
            state.fetchCartItems = action.payload;
        },
        setFetchPhysicalSaveLaterItems: (state, action) => {
            state.fetchPhysicalSaveLaterItems = action.payload;
        },
        setFetchVirtualSaveLaterItems: (state, action) => {
            state.fetchVirtualSaveLaterItems = action.payload;
        },
        setFetchAddToSaveLater: (state, action) => {
            state.fetchAddToSaveLater = action.payload;
        },
        setFetchDeleteFromSaveLater: (state, action) => {
            state.fetchDeleteFromSaveLater = action.payload;
        },
        setFetchDeleteItemFromCart: (state, action) => {
            state.fetchDeleteItemFromCart = action.payload;
        },
        setPatchSaveLaterItemFromCart: (state, action) => {
            state.patchSaveLaterItemFromCart = action.payload;
        },
        setDeleteItemFromCart: (state, action) => {
            state.deleteItemFromCart = action.payload;
        },
        setPromoCode: (state, action) => {
            state.promoCode = action.payload;
        }
    }
});

export const {
    setisSameAddress,
    setBillingAddress,
    setFetchCartTotalItem,
    setFetchCartItems,
    setFetchPhysicalSaveLaterItems,
    setFetchVirtualSaveLaterItems,
    setCartItemIndexChanged,
    setDeleteItemFromCart,
    setPatchSaveLaterItemFromCart,
    setPromoCode
} = cartSlice.actions;
export default cartSlice.reducer;
